import React from 'react';
import PropTypes from 'prop-types';

const IconOutlineButton = ({ className, iconSize, iconName, label, onClick }) => {
  IconOutlineButton.propTypes = {
    className: PropTypes.string,
    iconSize: PropTypes.string,
    iconName: PropTypes.string,
    label: PropTypes.string,
    onClick: PropTypes.func.isRequired
  };

  return (
    <div className={className}>
      <button
        className={`${iconSize} m-0 mb-1 text-center`}
        style={{ width: 60, height: 60, borderRadius: 30 }}
        onClick={onClick}
      >
        <span className='d-flex align-items-center justify-content-center'>
          <i className={`${iconName} m-0 p-0 h3`} />
        </span>
      </button>
      <small
        style={{ lineHeight: '15px', display: 'block' }}
        dangerouslySetInnerHTML={{ __html: label }}
      />
    </div>
  );
};

export default IconOutlineButton;
